import { RG_TYPE } from '../types/rg-type.js';
import { getRgObjectsOfType } from './get-rg-objects-of-type.js';

/** Iterates over all the buildings within a given RgObject parent (World | Site | Zone) to set their building.data.index
 * @param obj RgObject
*/
const setBuildingIndexes = (obj) => {
    const buildings = getRgObjectsOfType(obj, RG_TYPE.Building);
    const indexes = new Set(buildings.map(b => b.data.index));
    for (const building of buildings) {
        if (building.data.index !== undefined && building.data.index !== -1)
            continue;
        building.data.index = getNextIndex(indexes);
    }
};
/** Gets the next index number that's not already in use */
function getNextIndex(indexes) {
    let index = -1;
    do {
        index++;
    } while (indexes.has(index));
    indexes.add(index);
    return index;
}

export { setBuildingIndexes };
//# sourceMappingURL=set-building-indexes.js.map
